import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Button } from '../dialog-buttons.component';

import { DialogComponent } from '../dialog.component';

@Component({
  selector: 'delete-gallery-image-dialog',
  templateUrl: './delete-gallery-image-dialog.component.html',
  styleUrls: ['../dialog.scss'],
  standalone: false
})
export class DeleteGalleryImageDialogComponent extends DialogComponent
{
  constructor(@Inject(MAT_DIALOG_DATA) protected dialogData: any)
  {
    super(dialogData);
    this.buttons = {
      primary: Button.DELETE_IMAGE,
      secondary: Button.CANCEL,
    };
  }
}
